<div class="ac-page c7-access-view c7-access-legal-overview">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <app-back-button></app-back-button>
      <a class="ac-brand" routerLink="/login" aria-label="CULTURA">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let language of supportedLanguages" [value]="language.code">{{ language.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <main class="ac-main ac-main--center ac-main--top">
    <article class="ac-card ac-card--doc" aria-labelledby="ac-legal-title">
      <h1 id="ac-legal-title">{{ "legalPages.overviewTitle" | translate }}</h1>
      <p class="ac-doc__meta">{{ "legalPages.overviewLead" | translate }}</p>
      <ul class="ac-legal-list">
        <li *ngFor="let item of items">
          <a [routerLink]="item.route"><strong>{{ item.title | translate }}</strong></a>
          <span>{{ item.text | translate }}</span>
        </li>
      </ul>
      <p class="ac-doc__meta">{{ "legalPages.dpaNote" | translate }}</p>
    </article>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
